import React, { useEffect, useState, Suspense } from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';
import loadable from '@loadable/component'
import { decodeStorage } from 'functions/storageBase64';
import { useIsMobile } from 'hooks/useIsMobile';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { ErrorBoundary } from 'components/Error/ErrorBoundary'


const Header  = loadable( () => import (/* webpackChunkName: "Header" */ 'pages/Header/HeaderNavegacion/indexSuspense') )
const BarraCP  = loadable( () => import (/* webpackChunkName: "BarraCP" */ 'components/BarCP/BarHeaderCP/indexSuspense') )
const Footer = loadable(() => import(/* webpackChunkName: "Footer" */'pages/Footer/FooterDesktop/indexSuspense'))
const MenuPoliticas = loadable(() => import(/* webpackChunkName: "MenuPoliticas" */'components/MenuPoliticas/indexSuspense'))


export function PolticaReciboTelmexDesktop() {

    const { scrollToTop, subirVisible } = useScrollToTop();

    //recibe la direccion del CP
    const codigoP = decodeStorage('codigoPostal');
    const [, setCodigoPsotal] = useState(codigoP);
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setCodigoPsotal(val);
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(() => {
        if (upCP) {
            //console.log('')
        }
    }, [upCP, updateCPBar])

    return (
        <>
            <ErrorBoundary>
                <Suspense fallback={<header><div className="headerSup"></div><div className='headerInf'></div></header>}>
                    <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} />
                </Suspense>
            </ErrorBoundary>
            <section className="barCpResponsive">
                <ErrorBoundary>
                    <Suspense fallback={<div></div>}>
                        <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
                    </Suspense>
                </ErrorBoundary>
            </section>

            <h1 className="tituloPrincipal">Política Recibo Telmex</h1>
            <section className="sectionAuto">

                <div className="sectionMenu">
                    <ErrorBoundary>
                        <Suspense fallback={<div></div>}>
                            <MenuPoliticas />
                        </Suspense>
                    </ErrorBoundary>
                </div>

                <div className="sectionContent">
                    <>
                        <h2 className="h2Red">Requisitos para comprar en Claroshop.com</h2>
                        <ul className="ulContent mBottom">
                            <li>La línea Telmex deberá tener una antigüedad mínima de 6 meses.</li>
                            <li>Ser titular de la línea Telmex.</li>
                            <li>La contratación sólo podrá hacerse en líneas residenciales o comerciales.</li>
                            <li>Para clientes comerciales el representante legal deberá enviar por correo electrónico al correo <a href="mailto:clientes@claroshop.com" className="linkContent fontAzulLink">clientes@claroshop.com</a>, copia del acta constitutiva, poder e identificación oficial del representante, así como comprobante de domicilio reciente.</li>
                            <li>Cuando así lo requiera la empresa de mensajería, firmar carta de aceptación de los productos adquiridos, así como la documentación soporte de Claroshop.</li>
                            <li>Para las compras que se realicen a partir de las 00:01 horas del 3 de febrero de 2017, el Titular de la línea Telmex® deberá suscribir el pagaré que ampara el precio total de la compra, mismo que será exhibido y resguardado por la empresa de mensajería que realizará la entrega de los productos que se adquieran a través de la página.</li>
                           
                            <li>La línea Telmex debe contar con un Paquete Infinitum $349 o mayor.</li>
                            <li>Contar con un historial de pago excelente o bueno.</li>
                            <li>No contar con ningún saldo vencido en telecomunicaciones, ventas financiadas o terceros.</li>
                            <li>No tener orden de servicio abierta ( fallo en la línea Telmex o internet).</li>
                            <li>Contar con cuenta Mi Telmex.</li>
                            <li>La validación de la compra en en la línea Telmex y debe responder el titular de la línea.</li>
                            <li>El crédito de Telmex es distinto al de ClaroShop.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Envío</h2>
                        <p className="pContent mBottom">Claroshop.com realiza las entregas de los pedidos a través de prestigiadas empresas de paquetería, lo que nos permite brindar un servicio puntual y de calidad. Los gastos de envío están incluidos en el precio mostrado al momento de tu compra. Se informará al momento de hacer la compra en el portal o bien bajo promociones existentes.El tiempo de entrega de los productos será el especificado en la publicación del producto correspondiente.</p>
                    </>

                    <>
                        <h2 className="h2Red mTop">Requisitos de Entrega</h2>
                        <ul className="ulContent mBottom">
                            <li>La entrega del producto en domicilio de facturación Telmex® se realizará a cualquier persona que esté en dicho domicilio; y deberá  exhibir una identificación oficial (Credencial para votar, Pasaporte o Cédula profesional), la cual deberá tener la misma dirección que el domicilio al de facturación Telmex® del titular de la línea Telmex®.  Para las compras que se realicen a partir de las 00:01 horas del 3 de febrero de 2017, la entrega del producto, únicamente se realizará al Titular de la línea Telmex® en el domicilio de facturación, siempre y cuando el Titular de la línea Telmex® se identifique previamente y suscriba el pagaré que ampara el precio total de la compra.</li>
                            <li>La entrega del producto en domicilio distinto al de facturación Telmex®, se realizará al titular de la línea Telmex®. En caso de que el destinatario sea un tercero autorizado por el titular de la línea Telmex®, el destinatario deberá exhibir una identificación oficial del titular de la línea Telmex®.</li>
                            <li>Para las compras que se realicen a partir de las 00:01 horas del 3 de febrero de 2017, la entrega del producto en domicilio distinto al de facturación Telmex®, únicamente se realizará al Titular de la línea Telmex®, previa identificación y suscripción del pagaré que ampara el precio total de la compra.</li>
                            <li>El personal de mensajería no está obligado a la instalación de periféricos y/o software que solicite el Cliente.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Documentación</h2>
                        <ul className="ulContent mBottom">
                            <li>En caso de que lo requiera Claroshop, el titular de la línea deberá enviar electrónicamente (correo electrónico) copia de su identificación oficial (Credencial para votar, Pasaporte o Cédula profesional).</li>
                            <li>Se recabará la firma del titular por duplicado de la Carta de Aceptación y Pagaré; debiendo ser la misma de la identificación oficial.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Cobranza</h2>
                        <p className="pContent">Aplica sólo para productos adquiridos y cuyo medio de pago es con cargo al recibo Telmex®.<br></br>
                            En virtud de que está adquiriendo un producto mediante pagos mensuales y a plazo, con su consentimiento para que se le cobre a través de recibo Telmex®, acepta que en caso de que la línea Telmex® de la cual es titular y bajo la cual se cobrarán las mensualidades del producto, no pueda seguir asociándose a dicha facturación de Telmex® por cualquier causa, los pagos de las mensualidades correspondientes, los tendrá que hacer directamente en las tiendas Sears® y/o Sanborns® en la república mexicana hasta cubrir el total del monto adeudado por el producto en cuestión, obligándose el Cliente a liquidarlas en las mismas fechas de pago, a favor de Claroshop.com, S.A.P.I. de C.V., a través de depósito bancario a la cuenta que Claroshop indica en el portal, o pago en Tiendas Sears® o Sanborns® en la república mexicana.</p>
                        <p className="pContent mBottom">Una vez que el Titular de la línea Telmex® liquide totalmente el precio del producto adquirido, Claroshop.com, S.A.P.I. de C.V. cancelará el pagaré que el Titular de la línea Telmex® suscribió y lo pondrá a disposición del Titular de la línea Telmex®, en el domicilio ubicado en Venustiano Carranza No. 25, colonia Centro Histórico, delegación Cuauhtémoc, Ciudad de México.</p>
                    </>

                    <>
                        <h2 className="h2Red mTop">Ciclo de facturación</h2>
                        <ul className="ulContent mBottom">
                            <li>El cargo a recibo Telmex®, inicia una vez que el portal de Claroshop confirma la aprobación del pedido del producto.</li>
                            <li>Cuando lo requiera el Cliente, Claroshop.com expedirá el recibo fiscal correspondiente al producto adquirido.</li>
                            <li>La suspensión del servicio de la Línea por falta de pago, no libera al cliente del cargo mensual del producto adquirido a plazos.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Recibo Telmex</h2>
                        <p className="pContent">En el recibo Telmex se describe el producto de la siguiente manera:</p>
                        <ul className="ulContent mBottom">
                            <li>Número de mensualidad a pagar.</li>
                            <li>Plazo contratado.</li>
                            <li>Descuento por tipo de servicio contratado (Cuando aplique).</li>
                        </ul>
                    </>
                </div>
            </section>

            <p onClick={scrollToTop} className={subirVisible === true ? "subir verSubir" : "subir"}></p>
            <ErrorBoundary>
                <Suspense fallback={<div></div>}>
                    <Footer />
                </Suspense>
            </ErrorBoundary>
        </>
    )
}

export function PolticaReciboTelmexMobile() {
    const history = useHistory();

    const backHistory = () => {
        history.go(-1);
    };

    return (
        <>
            <section className="sectionAutoMobile">
                <div className="sectionTitleServicioCliente">
                    <button onClick={backHistory}>Política Recibo Telmex</button>
                </div>

                <div className="sectionContentMobile">
                    <>
                        <h2 className="h2Red">Requisitos para comprar en Claroshop.com</h2>
                        <ul className="ulContent mBottom">
                            <li>La línea Telmex deberá tener una antigüedad mínima de 6 meses.</li>
                            <li>Ser titular de la línea Telmex.</li>
                            <li>La contratación sólo podrá hacerse en líneas residenciales o comerciales.</li>
                            <li>Para clientes comerciales el representante legal deberá enviar por correo electrónico al correo <a href="mailto:clientes@claroshop.com" className="linkContent fontAzulLink">clientes@claroshop.com</a>, copia del acta constitutiva, poder e identificación oficial del representante, así como comprobante de domicilio reciente.</li>
                            <li>Cuando así lo requiera la empresa de mensajería, firmar carta de aceptación de los productos adquiridos, así como la documentación soporte de Claroshop.</li>
                            <li>Para las compras que se realicen a partir de las 00:01 horas del 3 de febrero de 2017, el Titular de la línea Telmex® deberá suscribir el pagaré que ampara el precio total de la compra, mismo que será exhibido y resguardado por la empresa de mensajería que realizará la entrega de los productos que se adquieran a través de la página.</li>
                 
                            <li>La línea Telmex debe contar con un Paquete Infinitum $349 o mayor.</li>
                            <li>Contar con un historial de pago excelente o bueno.</li>
                            <li>No contar con ningún saldo vencido en telecomunicaciones, ventas financiadas o terceros.</li>
                            <li>No tener orden de servicio abierta ( fallo en la línea Telmex o internet).</li>
                            <li>Contar con cuenta Mi Telmex.</li>
                            <li>La validación de la compra en en la línea Telmex y debe responder el titular de la línea.</li>
                            <li>El crédito de Telmex es distinto al de ClaroShop.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Envío</h2>
                        <p className="pContent mBottom">Claroshop.com realiza las entregas de los pedidos a través de prestigiadas empresas de paquetería, lo que nos permite brindar un servicio puntual y de calidad. Los gastos de envío están incluidos en el precio mostrado al momento de tu compra. Se informará al momento de hacer la compra en el portal o bien bajo promociones existentes.El tiempo de entrega de los productos será el especificado en la publicación del producto correspondiente.</p>
                    </>

                    <>
                        <h2 className="h2Red mTop">Requisitos de Entrega</h2>
                        <ul className="ulContent mBottom">
                            <li>La entrega del producto en domicilio de facturación Telmex® se realizará a cualquier persona que esté en dicho domicilio; y deberá  exhibir una identificación oficial (Credencial para votar, Pasaporte o Cédula profesional), la cual deberá tener la misma dirección que el domicilio al de facturación Telmex® del titular de la línea Telmex®.  Para las compras que se realicen a partir de las 00:01 horas del 3 de febrero de 2017, la entrega del producto, únicamente se realizará al Titular de la línea Telmex® en el domicilio de facturación, siempre y cuando el Titular de la línea Telmex® se identifique previamente y suscriba el pagaré que ampara el precio total de la compra.</li>
                            <li>La entrega del producto en domicilio distinto al de facturación Telmex®, se realizará al titular de la línea Telmex®. En caso de que el destinatario sea un tercero autorizado por el titular de la línea Telmex®, el destinatario deberá exhibir una identificación oficial del titular de la línea Telmex®.</li>
                            <li>Para las compras que se realicen a partir de las 00:01 horas del 3 de febrero de 2017, la entrega del producto en domicilio distinto al de facturación Telmex®, únicamente se realizará al Titular de la línea Telmex®, previa identificación y suscripción del pagaré que ampara el precio total de la compra.</li>
                            <li>El personal de mensajería no está obligado a la instalación de periféricos y/o software que solicite el Cliente.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Documentación</h2>
                        <ul className="ulContent mBottom">
                            <li>En caso de que lo requiera Claroshop, el titular de la línea deberá enviar electrónicamente (correo electrónico) copia de su identificación oficial (Credencial para votar, Pasaporte o Cédula profesional).</li>
                            <li>Se recabará la firma del titular por duplicado de la Carta de Aceptación y Pagaré; debiendo ser la misma de la identificación oficial.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Cobranza</h2>
                        <p className="pContent">Aplica sólo para productos adquiridos y cuyo medio de pago es con cargo al recibo Telmex®.<br></br>
                            En virtud de que está adquiriendo un producto mediante pagos mensuales y a plazo, con su consentimiento para que se le cobre a través de recibo Telmex®, acepta que en caso de que la línea Telmex® de la cual es titular y bajo la cual se cobrarán las mensualidades del producto, no pueda seguir asociándose a dicha facturación de Telmex® por cualquier causa, los pagos de las mensualidades correspondientes, los tendrá que hacer directamente en las tiendas Sears® y/o Sanborns® en la república mexicana hasta cubrir el total del monto adeudado por el producto en cuestión, obligándose el Cliente a liquidarlas en las mismas fechas de pago, a favor de Claroshop.com, S.A.P.I. de C.V., a través de depósito bancario a la cuenta que Claroshop indica en el portal, o pago en Tiendas Sears® o Sanborns® en la república mexicana.</p>
                        <p className="pContent mBottom">Una vez que el Titular de la línea Telmex® liquide totalmente el precio del producto adquirido, Claroshop.com, S.A.P.I. de C.V. cancelará el pagaré que el Titular de la línea Telmex® suscribió y lo pondrá a disposición del Titular de la línea Telmex®, en el domicilio ubicado en Venustiano Carranza No. 25, colonia Centro Histórico, delegación Cuauhtémoc, Ciudad de México.</p>
                    </>

                    <>
                        <h2 className="h2Red mTop">Ciclo de facturación</h2>
                        <ul className="ulContent mBottom">
                            <li>El cargo a recibo Telmex®, inicia una vez que el portal de Claroshop confirma la aprobación del pedido del producto.</li>
                            <li>Cuando lo requiera el Cliente, Claroshop.com expedirá el recibo fiscal correspondiente al producto adquirido.</li>
                            <li>La suspensión del servicio de la Línea por falta de pago, no libera al cliente del cargo mensual del producto adquirido a plazos.</li>
                        </ul>
                    </>

                    <>
                        <h2 className="h2Red mTop">Recibo Telmex</h2>
                        <p className="pContent">En el recibo Telmex se describe el producto de la siguiente manera:</p>
                        <ul className="ulContent mBottom">
                            <li>Número de mensualidad a pagar.</li>
                            <li>Plazo contratado.</li>
                            <li>Descuento por tipo de servicio contratado (Cuando aplique).</li>
                        </ul>
                    </>
                </div>
            </section>

            {/* <p onClick={scrollToTop} className={subirVisible === true ? "subir verSubir" : "subir"}></p> */}
        </>
    )
}

function PolticaReciboTelmex() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Section Telmex receipt policy');
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            {isMobile &&
                isMobile === 'desktop'
                ? <PolticaReciboTelmexDesktop />
                : <PolticaReciboTelmexMobile />
            }
        </>
    )
} 
export default React.memo(PolticaReciboTelmex)